import { render, staticRenderFns } from "./SuccessModal.vue?vue&type=template&id=588a0aa7"
import script from "./SuccessModal.vue?vue&type=script&lang=js"
export * from "./SuccessModal.vue?vue&type=script&lang=js"
import style0 from "./SuccessModal.vue?vue&type=style&index=0&id=588a0aa7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports